// TBD maybe move to `@ds-cps/ui`
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

import { SortDirection } from "@utils/sortUtil";

const fieldForActiveSort = "activeSort";
const fieldForDirection = "direction";

const toSortDirection = (
  sortDirection: string | null
): SortDirection | undefined => {
  if (!sortDirection) {
    return undefined;
  }
  switch (sortDirection.toLowerCase()) {
    case "ascending":
      return "ascending";
    case "descending":
      return "descending";
  }
  return sortDirection as SortDirection;
};

export interface SortOptions {
  prefix?: string;
  defaultSort?: string;
  defaultDirection?: SortDirection;
}

export const useSortQueryString = (options: SortOptions = {}) => {
  const { prefix } = options;
  const defaultSort = options.defaultSort ?? "";
  const defaultDirection = options.defaultDirection ?? "ascending";

  const [activeSort, setActiveSort] = useState(defaultSort);
  const [sortDirection, setSortDirection] =
    useState<SortDirection>(defaultDirection);

  const [activeSortField, setActiveSortName] = useState(fieldForActiveSort);
  const [directionField, setDirectionName] = useState(fieldForDirection);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (prefix && prefix !== "") {
      setActiveSortName(`${prefix}_${fieldForActiveSort}`);
      setDirectionName(`${prefix}_${fieldForDirection}`);
    } else {
      setActiveSortName(fieldForActiveSort);
      setDirectionName(fieldForDirection);
    }
  }, [prefix]);

  useEffect(() => {
    if (searchParams.has(activeSortField)) {
      setActiveSort(searchParams.get(activeSortField) ?? defaultSort);
    } else {
      setActiveSort(defaultSort);
    }

    if (searchParams.has(directionField)) {
      setSortDirection(
        toSortDirection(searchParams.get(directionField)) ?? defaultDirection
      );
    } else {
      setSortDirection(defaultDirection);
    }
  }, [
    activeSortField,
    directionField,
    searchParams,
    defaultSort,
    defaultDirection
  ]);

  const handleSort = (columnHeader: string) => {
    const currentParams = new URLSearchParams(globalThis.location.search);

    currentParams.set(activeSortField, columnHeader);
    if (activeSort === columnHeader) {
      if (sortDirection === "ascending") {
        currentParams.set(directionField, "descending");
      } else {
        currentParams.set(directionField, "ascending");
      }
    } else {
      currentParams.set(directionField, "ascending");
    }

    setSearchParams(currentParams);
  };

  return { activeSort, sortDirection, handleSort };
};
